import EventEmitter from "base/EventEmitter";
import GlobalEvents from "base/GlobalEvents";

export default class WebsiteModal extends EventEmitter {

    constructor(settings = {}) {
        super();
        this.isShown = false;
        this.$modal = null;
        this.settings = $.extend(true, {}, WebsiteModal.default_settings, settings);

        GlobalEvents.emit(GLOBAL_EVENT_MODAL_CREATED, this);
    }

    /**
     * @abstract
     */
    buildElement() {
        throw new Error("Website Modal must override buildElement()");
    }

    bindEvents() {
        // Noop
    }

    build() {
        if (!this.$modal) {
            this.buildElement();
            this.emit(EVENT_MODAL_BUILT);
            this.bindEvents();
            this.bindModalEvents();
        }
    }

    bindModalEvents() {
        if (this.settings.close.button) {
            this.$modal.on("click", WebsiteModal.global_settings.selectors.jsClose, () => {
                this.close();
                return false;
            });
        }
    }

    show() {

        this.build();

        if (this.isShown) return Promise.resolve();
        this.isShown = true;
        if (this.closeTimeout) clearTimeout(this.closeTimeout);

        this.emit(EVENT_SHOW);

        // If the modal isn't already in the DOM we remove the active class.
        // If we didn't check for this the modal would flash when attaching JavaScript
        if (this.$modal.parents("body").length === 0) {
            this.$modal.removeClass(WebsiteModal.global_settings.classes.active);

            $("body").append(this.$modal);
        }

        WebsiteModal.open_modals.push(this);
        return new Promise((resolve) => {
            setTimeout(() => {
                $("body").addClass(WebsiteModal.global_settings.classes.bodyModalActive);
                this.$modal.addClass(WebsiteModal.global_settings.classes.active);
                this.emit(EVENT_AFTER_SHOW);
                resolve();
            });
        });
    }

    hide() {
        // Hide the modal without firing the event
        if (!this.isShown) return;
        this.$modal.removeClass(WebsiteModal.global_settings.classes.active);
    }

    unhide() {
        // Unhide the modal without firing the event
        if (!this.isShown) return;
        this.$modal.addClass(WebsiteModal.global_settings.classes.active);
    }

    close() {
        if (!this.isShown) return Promise.resolve();
        this.$modal.removeClass(WebsiteModal.global_settings.classes.active);

        WebsiteModal.open_modals = WebsiteModal.open_modals.filter((other) => other !== this);
        if (!this.emit(EVENT_CLOSE)) {
            this.$modal.addClass(WebsiteModal.global_settings.classes.active);
            WebsiteModal.open_modals.push(this);
            return;
        }

        this.isShown = false;
        if (WebsiteModal.open_modals.length === 0) {
            $("body").removeClass(WebsiteModal.global_settings.classes.bodyModalActive);
        }

        return new Promise((resolve) => {
            if (this.isShown !== false) {
                resolve();
                return;
            }
            this.closeTimeout = setTimeout(() => {
                // The modal may have been destroyed at this point
                if (this.$modal) this.$modal.detach();
                this.emit(EVENT_CLOSE_DONE);
                resolve();
            }, 600);
        });
    }

    destroy() {
        if (this.isShown) {
            this.on(EVENT_CLOSE_DONE, () => this.destroy());
            this.close();

            return;
        }
        super.destroy();
        // Remove all listeners etc
        this.$modal.remove();

        this.$modal = null;
    }

    static close_all() {
        WebsiteModal.open_modals.forEach((modal) => modal.close());
    }

    static bind_events() {
        let $body = $("body");
        $body.on("click", "." + WebsiteModal.global_settings.classes.active + " " + WebsiteModal.global_settings.selectors.contentContainer, (e) => {
            e.stopPropagation();
        }).on("click", (e) => {
            let $target = $(e.target);
            if (!$body.is("." + WebsiteModal.global_settings.classes.bodyModalActive) || $target.parents("body").length === 0) {
                return;
            }

            WebsiteModal.open_modals.forEach((modal) => {
                if (modal.settings.close.background) {
                    modal.close();
                }
            });
        }).on("keyup", (e) => {
            if (e.which === 27 /* escape */) {
                WebsiteModal.open_modals.forEach((modal) => {
                    if (modal.settings.close.escape) {
                        modal.close();
                    }
                });
            }
        });
    }
}

WebsiteModal.default_settings = {
    close: {
        background: true, // Close on background click
        button: true, // Close when close button pressed
        escape: false, // Close when escape is pressed
    },
};

WebsiteModal.global_settings = {
    classes: {
        bodyModalActive: "modal-active",
        base: "modal",
        active: "modal--active",
    },
    selectors: {
        contentContainer: ".modal__container",
        jsClose: ".js-close-modal",
    },
};

export const GLOBAL_EVENT_MODAL_CREATED = 'websiteModal.created';

export const EVENT_SHOW = 'show';
export const EVENT_AFTER_SHOW = 'afterShow';
export const EVENT_CLOSE = 'close';
export const EVENT_CLOSE_DONE = 'closeDone';
export const EVENT_MODAL_BUILT = 'modalBuilt';

WebsiteModal.open_modals = [];

GlobalEvents.on(GLOBAL_EVENT_MODAL_CREATED, () => {
    WebsiteModal.bind_events();
}, true);
